<template>
	<section class="extra-item-manage">
		<div class="pm-toolbar">
			<div class="pm-toolbar__filters">
				<el-input
					v-model="search"
					class="pm-search"
					clearable
					prefix-icon="el-icon-search"
					placeholder="搜索名称 / 说明"
					@keyup.enter.native="searchList"
					@clear="searchList" />
			</div>
			<div class="pm-toolbar__actions">
				<el-button v-if="canAdd" type="primary" icon="el-icon-plus" class="pm-btn-primary" @click="openForm()">添加附加项</el-button>
			</div>
		</div>

		<el-table
			v-loading="loading"
			:data="list"
			stripe
			class="pm-table"
			style="width: 100%"
			cell-class-name="pm-cell"
			header-cell-class-name="pm-header-cell">
			<el-table-column align="center" width="60" label="ID" prop="id" />
			<el-table-column align="left" min-width="140" prop="name" label="名称" show-overflow-tooltip />
			<el-table-column align="left" min-width="200" prop="remark" label="说明" show-overflow-tooltip />
			<el-table-column align="center" width="72" prop="weigh" label="排序" />
			<el-table-column align="center" width="88" label="启用">
				<template slot-scope="scope">
					<el-switch
						:value="normalizeStatus(scope.row.status)"
						:disabled="!canEdit || statusUpdatingId === scope.row.id"
						@change="toggleStatus(scope.row, $event)" />
				</template>
			</el-table-column>
			<el-table-column align="center" width="168" label="创建时间">
				<template slot-scope="scope"><span class="pm-time">{{ formatTime(scope.row.createtime) }}</span></template>
			</el-table-column>
			<el-table-column align="center" width="96" label="操作" fixed="right">
				<template slot-scope="scope">
					<div v-if="canEdit || canDel" class="row-actions">
						<el-tooltip v-if="canEdit" content="编辑" placement="top">
							<el-button type="text" icon="el-icon-edit" class="row-action-btn" @click="openForm(scope.row)" />
						</el-tooltip>
						<el-popconfirm v-if="canDel" @onConfirm="delRow(scope.row.id)"
							confirmButtonType="danger" confirmButtonText="删除" title="确定删除该附加项吗？">
							<el-button slot="reference" type="text" icon="el-icon-delete" class="row-action-btn row-action-btn--danger" />
						</el-popconfirm>
					</div>
					<span v-else>—</span>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
			class="pm-pagination"
			:hide-on-single-page="pageSingle"
			@current-change="changePage"
			@size-change="changePageSize"
			:current-page="page"
			:page-size="limit"
			:page-sizes="[10, 20, 50]"
			background
			layout="total, sizes, prev, pager, next"
			:total="listTotal" />

		<el-dialog :title="form.id ? '编辑附加项' : '添加附加项'" :visible.sync="formVisible" width="480px" append-to-body @close="resetForm">
			<el-form ref="extraItemForm" :model="form" :rules="formRules" label-width="72px">
				<el-form-item label="名称" prop="name">
					<el-input v-model="form.name" maxlength="50" placeholder="如：运费、打包费" />
				</el-form-item>
				<el-form-item label="说明" prop="remark">
					<el-input v-model="form.remark" type="textarea" :rows="3" maxlength="200" placeholder="选填，给报价员的提示" />
				</el-form-item>
				<el-form-item label="排序" prop="weigh">
					<el-input-number v-model="form.weigh" :min="0" :max="9999" />
				</el-form-item>
				<el-form-item label="启用">
					<el-switch v-model="form.status" />
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="formVisible = false">取消</el-button>
				<el-button type="primary" :loading="saving" @click="saveForm">保存</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
export default {
	name: 'ExtraItemManage',
	props: {
		canAdd: { type: Boolean, default: false },
		canEdit: { type: Boolean, default: false },
		canDel: { type: Boolean, default: false },
	},
	data() {
		return {
			loading: false,
			saving: false,
			search: '',
			page: 1,
			limit: 10,
			listTotal: 0,
			pageSingle: false,
			list: [],
			statusUpdatingId: 0,
			formVisible: false,
			form: {
				id: 0,
				name: '',
				remark: '',
				weigh: 0,
				status: true,
			},
			formRules: {
				name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
			},
		};
	},
	created() {
		this.getList();
	},
	methods: {
		formatTime(ts) {
			const n = Number(ts);
			if (!n) return '—';
			const d = new Date(n * 1000);
			const pad = (v) => String(v).padStart(2, '0');
			return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
		},
		normalizeStatus(status) {
			return status === true || status === 1 || status === '1';
		},
		getList() {
			const that = this;
			that.loading = true;
			that.$fetch('addons/hlm/api.ExtraItem/manageList', {
				page: that.page,
				limit: that.limit,
				search: that.search,
			}).then(function(res) {
				if (res.code === 1) {
					that.list = res.data.list || [];
					that.listTotal = res.data.total || 0;
					that.pageSingle = that.listTotal <= that.limit;
				}
			}).finally(function() {
				that.loading = false;
			});
		},
		searchList() {
			this.page = 1;
			this.getList();
		},
		changePage(e) {
			this.page = e;
			this.getList();
		},
		changePageSize(size) {
			this.limit = size;
			this.page = 1;
			this.getList();
		},
		openForm(row) {
			if (row && row.id) {
				this.form = {
					id: row.id,
					name: row.name || '',
					remark: row.remark || '',
					weigh: Number(row.weigh) || 0,
					status: this.normalizeStatus(row.status),
				};
			} else {
				this.resetForm();
			}
			this.formVisible = true;
			this.$nextTick(() => {
				if (this.$refs.extraItemForm) this.$refs.extraItemForm.clearValidate();
			});
		},
		resetForm() {
			this.form = { id: 0, name: '', remark: '', weigh: 0, status: true };
		},
		saveForm() {
			const that = this;
			that.$refs.extraItemForm.validate(function(valid) {
				if (!valid) return;
				that.saving = true;
				that.$post('addons/hlm/api.ExtraItem/manageSave', Object.assign({}, that.form)).then(function(res) {
					if (res.code === 1) {
						that.$message.success(res.msg || '保存成功');
						that.formVisible = false;
						that.getList();
					}
				}).finally(function() {
					that.saving = false;
				});
			});
		},
		delRow(id) {
			const that = this;
			that.$fetch('addons/hlm/api.ExtraItem/manageDel', { ids: String(id) }).then(function(res) {
				if (res.code === 1) {
					that.$message.success('删除成功');
					that.getList();
				}
			});
		},
		toggleStatus(row, nextStatus) {
			const that = this;
			if (!that.canEdit || !row || !row.id) return;
			const prevStatus = that.normalizeStatus(row.status);
			if (prevStatus === nextStatus) return;
			that.statusUpdatingId = row.id;
			row.status = nextStatus;
			that.$fetch('addons/hlm/api.ExtraItem/manageSetStatus', {
				id: row.id,
				status: nextStatus ? 1 : 0,
			}).then(function(res) {
				if (res.code === 1) {
					that.$message.success(res.msg || '状态已更新');
				} else {
					row.status = prevStatus;
				}
			}).catch(function() {
				row.status = prevStatus;
			}).finally(function() {
				that.statusUpdatingId = 0;
			});
		},
	},
};
</script>

<style scoped>
.extra-item-manage {
	padding-top: 0;
}
.extra-item-manage >>> .pm-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 12px;
	padding: 16px 20px;
	border-bottom: 1px solid var(--app-border, #e5e7eb);
}
.extra-item-manage >>> .pm-toolbar__filters {
	display: flex;
	align-items: center;
	gap: 10px;
}
.extra-item-manage >>> .pm-search {
	width: 260px;
}
.extra-item-manage >>> .pm-pagination {
	display: flex;
	justify-content: flex-end;
	padding: 16px 20px;
	border-top: 1px solid var(--app-border, #e5e7eb);
}
.extra-item-manage >>> .row-actions {
	display: inline-flex;
	align-items: center;
	gap: 2px;
}
</style>
